export const API_URL = process.env.REACT_APP_REST_URL;
const SeasonYear = 2020;
const headers = new Headers();
headers.append('X-Api-Key', process.env.REACT_APP_REST_API_KEY);
const DefaultRequest = {
    method: 'GET',
    headers,
    mode: 'cors'
}
const handleErrors = (resp) => {
    if (!resp.ok) {
        throw Error(resp.status);
    }
    return resp;
}

export function getSubscriptionId(league, gameId) {
    return `${league}.${gameId}`;
}

export const fetchConf = async () => {
    const resp = await fetch(`${API_URL}/config/`, DefaultRequest);

    return await resp.json();
}

export function fetchLeagueGames(league) {
    return fetch(`${API_URL}/odds/${league}`, DefaultRequest)
}

export function fetchFootballGamesByWeek(league, season, weekNumber) {
    season = season || 'REG';

    switch (season.toLowerCase()) {
        case 'preseason':
            season = 'PRE';
            break;
        case 'playoffs':
            season = 'PST';
            break;
        default:
            break;
    }

    return fetch(`${API_URL}/odds/${league}/${season}/${SeasonYear}/week-${weekNumber}`, DefaultRequest);
}

export function fetchLeagueGamesByDateRange(league, startDate, endDate) {
    return fetch(`${API_URL}/odds/${league}?from=${startDate}&to=${endDate}`, DefaultRequest);
}

export async function fetchGame(league, awayCompetitor , homeCompetitor, date) {
    const resp = await fetch(`${API_URL}/games/${league}/${awayCompetitor}/vs/${homeCompetitor}/@/${date}`, DefaultRequest);

    handleErrors(resp);

    return await resp.json();
}

export const fetchGames = async (leagueFilter, season, gameTime) => {
    let response;
    if (gameTime) {
        let weekNum;
        if (gameTime.includes('week')) {
            weekNum = gameTime.split('-')[1];
            response = await fetchFootballGamesByWeek(leagueFilter, season, weekNum);
        } else {
            response = await fetchLeagueGamesByDateRange(leagueFilter, gameTime, gameTime);
        }
    } else {
        response = await fetchLeagueGames(leagueFilter);
    }

    const respObj = await response.json();

    return Object.values(respObj);
}

export const fetchLeagueSchedule = (league, season) => {
    return fetch(API_URL + "/schedules/" + league + "/2020", DefaultRequest)
        .then((response) => response.json());
}

export const fetchLineHistory = async (matchupId, marketName, bookName) => {
    const url = `${API_URL}/matchups/${matchupId}/markets/${marketName}/${bookName}/history`;
    return fetch(url, DefaultRequest)
        .then((response) => response.json());
}

export const fetchMatchups = async (league) => {
    const url = `${API_URL}/matchups?sport=${league}`;
    return fetch(url, DefaultRequest)
        .then((response) => response.json());
}

export const fetchFutures = async (league) => {
    const url = `${API_URL}/futures/${league}`;
    const resp =  await fetch(url, DefaultRequest);

    handleErrors(resp);

    return await resp.json();
}

export const fetchFutureDetails = async (slug) => {
    const url = `${API_URL}/futures?slug=${slug}`;
    const resp = await fetch(url, DefaultRequest);

    handleErrors(resp);

    return resp.json();
}